import { createMuiTheme } from '@material-ui/core';

const black = '#000000';
const white = '#FFFFFF';

const palette = {
  palette: {
    primary: {
      contrastText: white,
      dark: '#475974',
      main: '#385f99',
      light: '#b0bdcf',
      disabled: '#767676',
    },
    secondary: {
      contrastText: white,
      dark: '', // NEEDED
      main: '#76b1e2',
      light: '', // NEEDED
    },
    text: {
      primary: black,
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
    grey: {
      600: '#767676',
    },
    error: {
      contrastText: black,
      dark: '', // NEEDED
      main: '#d22c2c',
      light: '', // NEEDED
    },
    disabled: {
      main: '#676767',
    },
  },
  typography: {
    fontFamily: 'Source Sans Pro',

    select: {
      backgroundColor: 'red',
      classes: {
        paper: {
          //
          backgroundColor: 'red',
        },
        list: {
          //
        },
      },
    },
  },

  overrides: {
    MuiButton: {
      root: {
        //
      },
    },
    MuiDialogContent: {
      root: {
        borderTop: '2px solid #e6e6e6',
        borderBottom: '2px solid #e6e6e6',
      },
    },
    MuiSelect: {
      icon: {
        top: 0,
        fontSize: '2em',
        marginRight: '-0.5em',
        height: '100%',
        color: 'black',
      },
      root: {},
    },
  },
};

export default createMuiTheme(palette);
